export default function withoutLeadingSlash(url: string) {
    return url.replace(/^\//, '');
}
